// extracted by mini-css-extract-plugin
export var infoRow = "_s1-2";
export var labelContainer = "_s1-0";
export var rightInfo = "_s1-1";